export default function GroupsPage() {
  return <h2>Coming soon</h2>;
}
